import axios from 'axios'
import store from '../store'
import {
  Message
} from 'element-ui'
const timeout = 30000
axios.defaults.withCredentials = true
// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: timeout
})

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  response => {
    if (response.status === 200) {

      if (response.data.code == 406) {
        store.commit('setToken', '')
        store.commit('setIsLogin', false)
        Message({
          message: '登陆已过期请重新登陆',
          type: 'warning'
        })

      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    console.log('error interceptors 接口返回值报错')
    if (error.response.status) {
      switch (error.response.status) {
        // 404请求不存在
        case 404:
          Message({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          })
          break
          // 其他错误，直接抛出错误提示
        default:

          Message({
            message: error.response.data.msg,
            type: 'error',
            duration: 1500,
            forbidClick: true
          })
      }
      return Promise.reject(error.response)
    }
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js